import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MaterialInput from "../../components/MaterialInput";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialBox from "../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialSelect from "../../components/MasterSelect";
import EditIcon from "@mui/icons-material/Edit";
import { useUserDetails } from "../../context/auth";
import "react-phone-input-2/lib/style.css";
import { State } from "country-state-city";
import MaterialButton from "../../components/MaterialButton";
import { fetchCompanyAll } from "../../ApiBaseUrl";
import "./Company.css";
import { useLoading } from "../../context/loading";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import BASEURL, { MEDIAURL } from "../Utils/Baseurl";
import { gql } from "@apollo/client";
import Swal from "sweetalert2";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
export const Company = () => {
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [list, setList] = useState({});
  const { validationMessages, setValidationMessages } = useUserDetails();
  const { circleLoading, setCirleLoading } = useLoading();
  const [validationStatus, setValidationStatus] = useState("default");
  const [employeeData, setEmployeeData] = useState({
    firstName: "",
    email: "",
    address: "",
    country: "",
    state: "",
    city: "",
    zipcode: "",
    contactNumber: "",
    website: "",
    gst: "",
    icon: "",

    firstNameStatus: "unchecked",
    emailStatus: "unchecked",
    addressStatus: "unchecked",
    countryStatus: "unchecked",
    stateStatus: "unchecked",
    zipcodeStatus: "unchecked",
    contactNumberStatus: "unchecked",
    cityStatus: "unchecked",
    websiteStatus: "unchecked",
    gstStatus: "unchecked",
    iconStatus: "unchecked",
  });

  // OnchangeFunction
  const handleEmployeeDataChange = (event, selectEvent) => {
    let employeeState = { ...employeeData };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "country") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          country: "",
        });

        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "state") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          state: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "city") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          city: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "countryCode") {
        const lengthRegex = new RegExp("^[A-Za-z0-9\\W]");
        setValidationMessages({
          ...validationMessages,
          countryCode: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      employeeState[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "firstName":
          {
            const alphaNLengthRegex = new RegExp("^([a-zA-Z0-9 ]{1,40})$");

            setValidationMessages({
              ...validationMessages,
              firstName: "",
            });

            // Remove spaces before counting characters
            const inputWithoutSpaces = event.target.value?.replace(/\s/g, "");

            if (
              alphaNLengthRegex.test(event.target.value?.trim()) &&
              inputWithoutSpaces.length <= 40
            ) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "icon":
          {
            const file = event?.target?.files[0];
            if (file) {
              const allowedTypes = [
                "image/jpeg",
                "image/png",
                "image/jpg",
              ];

              if (allowedTypes.includes(file.type)) {
                employeeState[event.target.name + "Status"] = "success";
              } else {
                employeeState[event.target.name + "Status"] = "error";
                alert("Only image files (JPG, PNG, JPEG) are allowed.");
                event.target.value = ""; // Reset the input field
              }
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "gst":
          {
            const alphaNLengthRegex = new RegExp(
              /^[0-3][0-9][A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/
            );

            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "website":
          {
            const alphaNLengthRegex = new RegExp(
              /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/
            );

            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "address":
          {
            const alphaNumberLengthRegex = new RegExp("^.{1,250}$", "s");
            setValidationMessages({
              ...validationMessages,
              address: "",
            });
            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "contactNumber":
          {
            const phoneRegex = new RegExp("^[0-9]{10}$");
            setValidationMessages({
              ...validationMessages,
              contactNumber: "",
            });
            if (phoneRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "zipcode":
          {
            const zipcodeRegex = new RegExp("^[0-9]{6}$");
            setValidationMessages({
              ...validationMessages,
              zipcode: "",
            });
            if (zipcodeRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "email":
          {
            const emailRegex = new RegExp(/^[\w.-]+@[\w-]+\.(com|in|yahoo)$/g);
            setValidationMessages({
              ...validationMessages,
              email: "",
            });
            if (emailRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (event?.target?.name == "icon") {
        employeeState[event.target.name] = event?.target?.files[0];
      } else {
        employeeState[event.target.name] = event.target.value;
      }
    }
    setEmployeeData(employeeState);
  };

  //disabled button function
  const disabledbtn = () => {
    let btn = false;
    if (
      employeeData?.firstNameStatus == "success" &&
      employeeData?.emailStatus == "success" &&
      employeeData?.addressStatus == "success" &&
      employeeData?.stateStatus == "success" &&
      employeeData?.zipcodeStatus == "success" &&
      employeeData?.contactNumberStatus == "success" &&
      employeeData?.gstStatus == "success" &&
      employeeData?.iconStatus == "success"
    ) {
      btn = false;
    } else {
      btn = true;
    }
    return btn;
  };


  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const uploadLink = createUploadLink({ uri: BASEURL });
  const client = new ApolloClient({
    link: uploadLink,
    cache: new InMemoryCache(),
  });

  const submitHandelar = async () => {
    setCirleLoading(true);
    const input = {
      companyName: employeeData?.firstName,
      address: employeeData?.address,
      state: employeeData?.state?.value,
      country: employeeData?.country?.value,
      zipCode: employeeData?.zipcode,
      phoneNumber: employeeData?.contactNumber,
      email: employeeData?.email,
      email: employeeData?.email,
      website: employeeData?.website,
      gstNumber: employeeData?.gst,
      country: "india",
    };

    let query;
    let variables = {
      companyData: input,
      logo: employeeData?.icon?.name ? employeeData?.icon : "",
    };

    if (togglePage?.view || togglePage?.edit) {
      query = gql`
        mutation UpdateCompany(
          $id: Int!
          $companyData: CompanyInput!
          $logo: Upload
        ) {
          updateCompany(id: $id, companyData: $companyData, logo: $logo) {
            company {
              id
              companyName
              address
              state
              country
              zipCode
              logo
              phoneNumber
              email
              website
              gstNumber
            }
          }
        }
      `;

      variables = {
        ...variables,
        id: +list?.id,
      };
    } else {
      query = gql`
        mutation AddCompany($companyData: CompanyInput!, $logo: Upload) {
          addCompany(companyData: $companyData, logo: $logo) {
            company {
              id
              companyName
              address
              state
              country
              zipCode
              logo
              phoneNumber
              email
              website
              gstNumber
            }
          }
        }
      `;
    }

    try {
      const response = await client.mutate({
        mutation: query,
        variables,
      });

      if (togglePage?.edit) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Edited  Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        setTogglePage({
          view: true,
          edit: false,
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Added  Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      }
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
    } catch (error) {
      console.error("Error fetching data by ID:", error);
      setConfirmationDialog({
        open: true,
        title: "Error Message",
        message: error?.message || "Something went wrong!",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const fetchdata = async () => {
    setCirleLoading(true);
    try {
      const response = await fetchCompanyAll("getCompany", [
        "id",
        "companyName",
        "address",
        "state",
        "country",
        "zipCode",
        "logo",

        "phoneNumber",
        "email",
        "website",
        "gstNumber",
      ]);

      const data = response?.getCompany[0];
      if (response?.getCompany?.length == 1) {
        setList(response?.getCompany[0]);

        setEmployeeData({
          firstName: data?.companyName,
          email: data?.email,
          address: data?.address,
          country: { value: data?.country, label: data?.country },
          state: { value: data?.state, label: data?.state },

          zipcode: data?.zipCode,
          contactNumber: data?.phoneNumber,
          website: data?.website,
          gst: data?.gstNumber,
          icon: data?.logo,
          firstNameStatus: "success",
          emailStatus: "success",
          addressStatus: "success",
          countryStatus: "success",
          stateStatus: "success",
          zipcodeStatus: "success",
          contactNumberStatus: "success",
          cityStatus: "success",
          websiteStatus: "success",
          gstStatus: "success",
          iconStatus: "success",
        });
        if (response?.getCompany?.length == 1) {
          togglePage.view = true;
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setCirleLoading(false);
    }
  };
  useEffect(() => {
    fetchdata();
  }, []);
  const onAddShift = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        submitHandelar();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const discard = () => {
    setEmployeeData({
      firstName: list?.companyName,
      email: list?.email,
      address: list?.address,
      country: { value: list?.country, label: list?.country },
      state: { value: list?.state, label: list?.state },
      zipcode: list?.zipCode,
      contactNumber: list?.phoneNumber,
      website: list?.website,
      gst: list?.gstNumber,
      icon: list?.logo,
      firstNameStatus: "success",
      emailStatus: "success",
      addressStatus: "success",
      countryStatus: "success",
      stateStatus: "success",
      zipcodeStatus: "success",
      contactNumberStatus: "success",
      cityStatus: "success",
      websiteStatus: "success",
      gstStatus: "success",
      iconStatus: "success",
    });
    setTogglePage({
      view: true,
      edit: false,
    });
    setValidationStatus("valid");
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {togglePage?.view
                    ? "View Company Details"
                    : togglePage?.edit
                    ? "Edit Company Details"
                    : "Add Company Details"}
                </MaterialTypography>
              </Stack>
              <ButtonGroup variant="outlined" aria-label="Loading button group">
                {togglePage.view && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={toggleEdit}
                    startIcon={<EditIcon />}
                  >
                    Edit
                  </MaterialButton>
                )}
              </ButtonGroup>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <Grid direction="row" container spacing={1}>
            <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Company Name <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="firstName"
                placeholder="eg.Company Name"
                value={employeeData.firstName}
                onChange={handleEmployeeDataChange}
                error={employeeData.firstNameStatus === "error" ? true : false}
                success={
                  employeeData.firstNameStatus === "success" ? true : false
                }
                disabled={togglePage.view === true ? true : false}
                inputProps={{
                  style: { backgroundColor: "transparent" }, // or your desired color
                }}
              />
              {employeeData.firstNameStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Company Name should be maximum 40 characters long
                  </FormHelperText>
                </FormControl>
              )}
              {validationMessages.firstName && (
                <label style={{ color: "red", fontSize: "12px" }}>
                  {validationMessages.firstName}
                </label>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Email Id <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="email"
                placeholder="eg: ajithkumar@gmail.com"
                value={employeeData.email}
                onChange={handleEmployeeDataChange}
                error={employeeData.emailStatus === "error" ? true : false}
                success={employeeData.emailStatus === "success" ? true : false}
                disabled={togglePage.view === true ? true : false}
              />
              {employeeData.emailStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Please enter a valid email address
                  </FormHelperText>
                </FormControl>
              )}
              {validationMessages.email && (
                <label style={{ color: "red", fontSize: "12px" }}>
                  {validationMessages.email}
                </label>
              )}
            </Grid>
            <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  GST Number <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="gst"
                placeholder="eg. 123456"
                value={employeeData.gst}
                onChange={handleEmployeeDataChange}
                error={employeeData.gstStatus === "error"}
                success={employeeData.gstStatus === "success"}
                disabled={togglePage.view === true ? true : false}
              />
              {employeeData.gstStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Please enter a valid GST number consisting of 15 characters,
                    including a state code, PAN, entity code, 'Z' at the 14th
                    position, and a checksum digit.
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Website
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="website"
                placeholder="eg. website"
                value={employeeData.website}
                onChange={handleEmployeeDataChange}
                error={employeeData.websiteStatus === "error"}
                success={employeeData.websiteStatus === "success"}
                disabled={togglePage.view === true ? true : false}
              />
              {employeeData.websiteStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Please enter a valid website URL, starting with http:// or
                    https:// (e.g., https://www.example.com).
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  State <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="state"
                value={employeeData.state}
                customStyles={{ optionPadding: 20 }}
                onChange={handleEmployeeDataChange}
                options={State.getStatesOfCountry("IN").map((value) => {
                  return {
                    value: value.name,
                    label: value.name,
                    isoCode: value.isoCode,
                    countryCode: value.countryCode,
                  };
                })}
                error={employeeData.stateStatus === "error" ? true : false}
                success={employeeData.stateStatus === "success" ? true : false}
                isDisabled={togglePage.view === true ? true : false}
              />
              {validationMessages.state && (
                <label style={{ color: "red", fontSize: "12px" }}>
                  {validationMessages.state}
                </label>
              )}
            </Grid>
            <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Address <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="address"
                multiline
                rows={3}
                placeholder="eg.Address"
                value={employeeData.address}
                onChange={handleEmployeeDataChange}
                disabled={togglePage.view === true ? true : false}
                error={employeeData.addressStatus === "error" ? true : false}
                success={
                  employeeData.addressStatus === "success" ? true : false
                }
              />
              {employeeData.addressStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Address must be between 1 and 250 characters.
                  </FormHelperText>
                </FormControl>
              )}
              {validationMessages.address && (
                <label style={{ color: "red", fontSize: "12px" }}>
                  {validationMessages.address}
                </label>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Zip Code <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="zipcode"
                placeholder="eg. 123456"
                value={employeeData.zipcode}
                onChange={handleEmployeeDataChange}
                error={employeeData.zipcodeStatus === "error"}
                success={employeeData.zipcodeStatus === "success"}
                disabled={togglePage.view === true ? true : false}
              />
              {employeeData.zipcodeStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Zip Code should be a 6 digit number.
                  </FormHelperText>
                </FormControl>
              )}
              {validationMessages.zipcode && (
                <label style={{ color: "red", fontSize: "12px" }}>
                  {validationMessages.zipcode}
                </label>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Contact Number <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="contactNumber"
                placeholder="eg: 7865344543"
                value={employeeData.contactNumber}
                onChange={handleEmployeeDataChange}
                disabled={togglePage.view === true ? true : false}
                error={
                  employeeData.contactNumberStatus === "error" ? true : false
                }
                success={
                  employeeData.contactNumberStatus === "success" ? true : false
                }
              />

              {employeeData.contactNumberStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Contact Number must be exactly 10 digits with no spaces or
                    special characters.
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Company Icon <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>

              <label class="custum-file-upload" for="file">
                {employeeData?.icon ? (
                  <div class="icon">
                    <img
                      src={
                        employeeData?.icon?.name
                          ? URL.createObjectURL(employeeData?.icon)
                          : `${MEDIAURL}media/${employeeData?.icon}`
                      }
                      alt="no logo"
                    />
                  </div>
                ) : (
                  <>
                    <div class="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill=""
                        viewBox="0 0 24 24"
                      >
                        <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
                        <g
                          stroke-linejoin="round"
                          stroke-linecap="round"
                          id="SVGRepo_tracerCarrier"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          {" "}
                          <path
                            fill=""
                            d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                            clip-rule="evenodd"
                            fill-rule="evenodd"
                          ></path>{" "}
                        </g>
                      </svg>
                    </div>
                    <div class="text">
                      <span>Click to upload image</span>
                    </div>
                  </>
                )}
                <input
                  type="file"
                  id="file"
                  name="icon"
                  onChange={handleEmployeeDataChange}
                  disabled={togglePage.view === true ? true : false}
                  accept="image/*"
                />
              </label>
            </Grid>
          </Grid>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {togglePage?.edit && (
            <>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={discard}
              >
                DisCard
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={disabledbtn()}
                onClick={onAddShift}
              >
                Update
              </MaterialButton>
            </>
          )}
          {!togglePage?.view && !togglePage?.edit && (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={disabledbtn()}
                onClick={onAddShift}
              >
                submit
              </MaterialButton>
            </div>
          )}
        </MaterialBox>
      </Card>
    </DashboardLayout>
  );
};
